/**
 * this is the controller to handle actions and settings for the toolbar
 **/
export default class ToolbarController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector, $scope) {
		this.$rootScope = $injector.get("$rootScope");
		this.$scope = $scope;
		this.SidebarService = $injector.get('SidebarService');
	}

	/**
	 * initialize the component
	 **/
	$onInit() {
		this.showSidebar = this.SidebarService.isOpen();
		this.registerEvents();
	}

	registerEvents() {
		this.$scope.$on('toolbar:updateTitle', (events, args) => {
			this.title = args.title;
		});
	}

	toggleSidebar() {
		this.showSidebar = this.SidebarService.toggleSidebar();
	}
}
